import React from 'react'
import HomeLayout from '../components/Layouts/HomeLayout';


const IndexPage = () => <HomeLayout />
    
export default IndexPage;
